export const GET_MASTER_HIERARCHY_REQUEST = "GET_MASTER_HIERARCHY_REQUEST";
export const GET_MASTER_HIERARCHY_SUCCESS = "GET_MASTER_HIERARCHY_SUCCESS";
export const GET_MASTER_HIERARCHY_FAILURE = "GET_MASTER_HIERARCHY_FAILURE";

export const GET_TENANT_HIERARCHY_CONFIGURATION_REQUEST = "GET_TENANT_HIERARCHY_CONFIGURATION_REQUEST";
export const GET_TENANT_HIERARCHY_CONFIGURATION_SUCCESS = "GET_TENANT_HIERARCHY_CONFIGURATION_SUCCESS";
export const GET_TENANT_HIERARCHY_CONFIGURATION_FAILURE = "GET_TENANT_HIERARCHY_CONFIGURATION_FAILURE";

export const SAVE_TENANT_HIERARCHY_CONFIGURATION_REQUEST = "SAVE_TENANT_HIERARCHY_CONFIGURATION_REQUEST";
export const SAVE_TENANT_HIERARCHY_CONFIGURATION_SUCCESS = "SAVE_TENANT_HIERARCHY_CONFIGURATION_SUCCESS";
export const SAVE_TENANT_HIERARCHY_CONFIGURATION_FAILURE = "SAVE_TENANT_HIERARCHY_CONFIGURATION_FAILURE";

export const BULK_UPDATE_TENANT_HIERARCHY_ALIAS_REQUEST = "BULK_UPDATE_TENANT_HIERARCHY_ALIAS_REQUEST";
export const BULK_UPDATE_TENANT_HIERARCHY_ALIAS_SUCCESS = "BULK_UPDATE_TENANT_HIERARCHY_ALIAS_SUCCESS";
export const BULK_UPDATE_TENANT_HIERARCHY_ALIAS_FAILURE = "BULK_UPDATE_TENANT_HIERARCHY_ALIAS_FAILURE";

export const RESET_TENANT_HIERARCHY_CONFIGURATION_FLAGS = "RESET_TENANT_HIERARCHY_CONFIGURATION_FLAGS";
